module.exports = __webpack_public_path__ + "static/media/left-arrow.b0b58952.svg";